import React from 'react';
import { VocabProvider } from '@vocab/react';
import { Router } from './Router';
import { BraidProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import { AppContextProvider, useAppContext } from './context/AppContext';
import type { ConfigOptions } from 'src/render';

interface AppProps {
  config: ConfigOptions;
}

const App = () => {
  const { language } = useAppContext();
  return (
    <VocabProvider language={language}>
      <BraidProvider theme={seekJobs}>
        <Router />;
      </BraidProvider>
    </VocabProvider>
  );
};

export default ({ config }: AppProps) => {
  return (
    <AppContextProvider {...config}>
      <App />
    </AppContextProvider>
  );
};
